
import { defineComponent } from "vue";
import BaseButton from "~/components/base/BaseButton.vue";
import useBookingNavigation from "@/composables/useBookingNavigation"

export default defineComponent({
    components: { BaseButton },
    setup() {
        const { steps, currentStep, goToStep, completedSteps } =
            useBookingNavigation();

        return { steps, currentStep, goToStep, completedSteps };
    },
});
